import Vue from 'vue'
import Vuex from 'vuex';
import login from './modules/main/login.js';
import ucenter from './modules/main/ucenter.js';


Vue.use(Vuex);

let store = new Vuex.Store({
	modules: {
		login,
		ucenter,
	}
});

export default store;
